import { useState, Key, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { IPurchaseRoFields, IDetailList, IPurchaseDetails } from './vrmBillPurchaseRoType';
import { purchaseRoService } from './vrmBillPurchaseService';
import { useVrmSaleRoDetailModel } from '../vrmBillSaleRo/vrmBillSaleRoModel';
import useGlobalModel from '@/model/globalModel';
import useNavModel from '@/model/navModel';
export type IVrmRoDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	paidAmount: number;
	[key: string]: any;
};
//这里为了继承一个弹框列表的自定义属性值
export interface IMaterialDetailModel extends IPurchaseDetails {
	purchaseNum?: number;
	detailsId?: string;
	// num: number,
	// amount: number,
	// confirmNum?: number,    // 0,
	// damageNum?: number,    // 0,
	// unarrivedNum?: number,    // 0,
}
export const useVrmPurchaseRoDetailsModel = createModel(function () {
	const { userBranch } = useGlobalModel()
	const { selectedNavId, replaceNav } = useNavModel();
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		paidAmount: 0,
	};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const { getVrmTreeNodeName } = useVrmSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IPurchaseRoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<IVrmRoDescType>(initDesc);

	//设置底部总数展示（查看|编辑|查看）
	useEffect(() => {
		let newDesc: IVrmRoDescType = { ...initDesc };
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.num) * Number(item.price);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await purchaseRoService.one(id,userBranch);
		if (retData) {
			const { details, ...from } = retData;
			setDetailLookForm({
				...from,
				supplierTypeName: getVrmTreeNodeName(from.supplierTypeCode as string),
				invoiceTypeName: getVrmTreeNodeName(from.invoiceTypeCode as string),
				payType: getVrmTreeNodeName(from.payType as string),
				payMethodName: getVrmTreeNodeName(from.payMethodName as string),
			});
			setDetailLookList((details as IDetailList[]) ?? []);
		}
	};

	// 采购退单 跳转 采购单
	const goToPurchaseDetail = (code: string, branch: string) => {
		if (branch === 'scm' || userBranch === 'scm') {
			replaceNav(
				selectedNavId,
				"10-3",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		} else if (branch === 'ci' || userBranch === 'ci') {
			replaceNav(
				selectedNavId,
				"11-3",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		} else if (branch === 'bcm' || userBranch === 'bcm') {
			replaceNav(
				selectedNavId,
				"12-3",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		}
	}
	// 销售退单 跳转 销售单
	const goToSaleDetail = (code: string, branch: string) => {
		if (branch === 'scm' || userBranch === 'scm') {
			replaceNav(
				selectedNavId,
				"10-2",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		} else if (branch === 'ci' || userBranch === 'ci') {
			replaceNav(
				selectedNavId,
				"11-2",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		} else if (branch === 'bcm' || userBranch === 'bcm') {
			replaceNav(
				selectedNavId,
				"12-2",
				{
					id: code as string, mode: "",
					parentInfo: {
						selectedNavId,
					}
				},
				true)
		}
	}
	// 维修退单 跳转 采购单

	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailLookList([]);
	};

	return {
		// data
		initPgCfg,
		detailLookForm,
		detailLookList,
		lookDesc,
		// model
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
		goToPurchaseDetail,
		goToSaleDetail
	};
});
